import store from '../../store';
export default function getFullTable(localEntityName) {
    const state = store.state[localEntityName] || {};
    const fullTable = state.fullTable || [];
    return fullTable;
}
